import React from 'react';
import { Wallet, Trophy, CheckCircle, ArrowRight, Banknote, CreditCard, History, Star, Clock, ChevronRight, Sparkles } from 'lucide-react';

// Option A: Golf Scorecard Style
export const ScorecardWallet = () => (
  <div className="min-h-screen bg-emerald-900 p-4">
    {/* Scorecard Header */}
    <div className="max-w-md mx-auto">
      <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Course Name Header */}
        <div className="bg-emerald-700 px-6 py-4 text-center">
          <h1 className="text-white font-bold text-lg tracking-wide">GOLF WALLET</h1>
          <p className="text-emerald-200 text-xs">Par Seeker Tournament Account</p>
        </div>
        
        {/* Balance - Like a Score */}
        <div className="px-6 py-8 text-center border-b-2 border-dashed border-gray-200">
          <p className="text-gray-500 text-sm uppercase tracking-wider mb-2">Your Balance</p>
          <p className="text-5xl font-bold text-emerald-700">$45.00</p>
          <p className="text-gray-400 text-sm mt-2">Ready to withdraw</p>
        </div>
        
        {/* Setup Holes */}
        <div className="px-6 py-6">
          <p className="text-gray-500 text-xs uppercase tracking-wider mb-4">Setup Progress</p>
          <div className="flex justify-between items-center">
            {/* Hole 1 */}
            <div className="text-center">
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mb-2 mx-auto">
                <CheckCircle className="w-6 h-6 text-emerald-600" />
              </div>
              <p className="text-xs text-gray-600">Verified</p>
            </div>
            <div className="h-0.5 flex-1 bg-emerald-200 mx-2" />
            {/* Hole 2 */}
            <div className="text-center">
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mb-2 mx-auto">
                <CheckCircle className="w-6 h-6 text-emerald-600" />
              </div>
              <p className="text-xs text-gray-600">Bank</p>
            </div>
            <div className="h-0.5 flex-1 bg-gray-200 mx-2" />
            {/* Hole 3 */}
            <div className="text-center">
              <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-2 mx-auto border-2 border-dashed border-gray-300">
                <CreditCard className="w-5 h-5 text-gray-400" />
              </div>
              <p className="text-xs text-gray-400">Card</p>
            </div>
          </div>
        </div>
        
        {/* Actions */}
        <div className="px-6 pb-6 space-y-3">
          <button className="w-full bg-emerald-600 text-white py-4 rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-emerald-700 transition">
            <Banknote className="w-5 h-5" />
            Withdraw Funds
          </button>
          <button className="w-full bg-gray-100 text-gray-700 py-3 rounded-xl font-medium flex items-center justify-center gap-2 hover:bg-gray-200 transition">
            <History className="w-5 h-5" />
            Transaction History
          </button>
        </div>
      </div>
    </div>
  </div>
);

// Option B: VIP Golf Club Style
export const VIPWallet = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black p-4">
    <div className="max-w-md mx-auto pt-8">
      {/* Premium Card */}
      <div className="relative">
        {/* Glow Effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/20 to-amber-500/20 rounded-3xl blur-xl" />
        
        <div className="relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl p-6 border border-gray-700 shadow-2xl">
          {/* Card Header */}
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center">
                <Trophy className="w-5 h-5 text-white" />
              </div>
              <div>
                <h1 className="text-white font-bold">GOLF WALLET</h1>
                <p className="text-gray-500 text-xs">Premium Member</p>
              </div>
            </div>
            <div className="flex gap-1">
              <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
              <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
              <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
            </div>
          </div>
          
          {/* Balance */}
          <div className="mb-8">
            <p className="text-gray-500 text-sm mb-1">Available Balance</p>
            <p className="text-5xl font-bold text-white">
              $45<span className="text-2xl text-gray-400">.00</span>
            </p>
          </div>
          
          {/* Stats Row */}
          <div className="grid grid-cols-3 gap-4 mb-8">
            <div className="bg-white/5 rounded-xl p-3 text-center">
              <p className="text-emerald-400 font-bold text-lg">$230</p>
              <p className="text-gray-500 text-xs">Lifetime Won</p>
            </div>
            <div className="bg-white/5 rounded-xl p-3 text-center">
              <p className="text-amber-400 font-bold text-lg">12</p>
              <p className="text-gray-500 text-xs">Tournaments</p>
            </div>
            <div className="bg-white/5 rounded-xl p-3 text-center">
              <p className="text-blue-400 font-bold text-lg">5</p>
              <p className="text-gray-500 text-xs">Wins</p>
            </div>
          </div>
          
          {/* Actions */}
          <div className="flex gap-3">
            <button className="flex-1 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white py-4 rounded-xl font-semibold hover:from-emerald-600 hover:to-emerald-700 transition">
              Withdraw
            </button>
            <button className="flex-1 bg-white/10 text-white py-4 rounded-xl font-semibold hover:bg-white/20 transition">
              Add Funds
            </button>
          </div>
          
          {/* Member Since */}
          <p className="text-center text-gray-600 text-xs mt-6">Member since July 2026</p>
        </div>
      </div>
    </div>
  </div>
);

// Option C: Simple Steps Style
export const SimpleWallet = () => (
  <div className="min-h-screen bg-gray-50 p-4">
    <div className="max-w-md mx-auto pt-4">
      {/* Clean Header */}
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-2xl bg-emerald-500 flex items-center justify-center mx-auto mb-4 shadow-lg shadow-emerald-500/30">
          <Wallet className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Golf Wallet</h1>
        <p className="text-gray-500">Your tournament earnings</p>
      </div>
      
      {/* Big Balance */}
      <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 text-center mb-6">
        <p className="text-gray-400 text-sm mb-2">Available Balance</p>
        <p className="text-6xl font-bold text-gray-900 mb-4">$45</p>
        <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full text-sm">
          <Sparkles className="w-4 h-4" />
          Ready to withdraw!
        </div>
      </div>
      
      {/* Simple Action Cards */}
      <div className="space-y-3">
        <button className="w-full bg-emerald-500 text-white p-5 rounded-2xl flex items-center justify-between hover:bg-emerald-600 transition group">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center">
              <Banknote className="w-6 h-6" />
            </div>
            <div className="text-left">
              <p className="font-semibold text-lg">Withdraw</p>
              <p className="text-emerald-100 text-sm">To your bank account</p>
            </div>
          </div>
          <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition" />
        </button>
        
        <button className="w-full bg-white p-5 rounded-2xl flex items-center justify-between hover:bg-gray-50 transition group border border-gray-100">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center">
              <CreditCard className="w-6 h-6 text-blue-500" />
            </div>
            <div className="text-left">
              <p className="font-semibold text-lg text-gray-900">Add Card</p>
              <p className="text-gray-500 text-sm">For tournament entries</p>
            </div>
          </div>
          <ChevronRight className="w-6 h-6 text-gray-400 group-hover:translate-x-1 transition" />
        </button>
        
        <button className="w-full bg-white p-5 rounded-2xl flex items-center justify-between hover:bg-gray-50 transition group border border-gray-100">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-purple-50 flex items-center justify-center">
              <History className="w-6 h-6 text-purple-500" />
            </div>
            <div className="text-left">
              <p className="font-semibold text-lg text-gray-900">History</p>
              <p className="text-gray-500 text-sm">View transactions</p>
            </div>
          </div>
          <ChevronRight className="w-6 h-6 text-gray-400 group-hover:translate-x-1 transition" />
        </button>
      </div>
      
      {/* Setup Progress */}
      <div className="mt-8 bg-white rounded-2xl p-5 border border-gray-100">
        <div className="flex items-center justify-between mb-3">
          <p className="font-medium text-gray-900">Setup Progress</p>
          <p className="text-emerald-600 font-semibold">2 of 3</p>
        </div>
        <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full w-2/3 bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full" />
        </div>
        <p className="text-gray-500 text-sm mt-2">Add a payment card to complete setup</p>
      </div>
    </div>
  </div>
);

// Demo page to show all three
const WalletMockups = () => {
  const [selected, setSelected] = React.useState('A');
  
  return (
    <div>
      {/* Selector */}
      <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 bg-white rounded-full shadow-lg p-1 flex gap-1">
        <button 
          onClick={() => setSelected('A')}
          className={`px-4 py-2 rounded-full text-sm font-medium transition ${selected === 'A' ? 'bg-emerald-500 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          A: Scorecard
        </button>
        <button 
          onClick={() => setSelected('B')}
          className={`px-4 py-2 rounded-full text-sm font-medium transition ${selected === 'B' ? 'bg-emerald-500 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          B: VIP Club
        </button>
        <button 
          onClick={() => setSelected('C')}
          className={`px-4 py-2 rounded-full text-sm font-medium transition ${selected === 'C' ? 'bg-emerald-500 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          C: Simple
        </button>
      </div>
      
      {/* Content */}
      {selected === 'A' && <ScorecardWallet />}
      {selected === 'B' && <VIPWallet />}
      {selected === 'C' && <SimpleWallet />}
    </div>
  );
};

export default WalletMockups;
